import React, { useEffect } from 'react';
import moment from 'moment-timezone';
import LoadingSpinner from '../spinner/LoadingSpinner';
import WithOnlyOnDesktop from '../onlyOnDesktop/withOnlyOnDesktop';
import ProfessionalsSubtype from './ProfessionalsSubtype';
import SSNField from './SSNField';

const mapCaregiversCertifications = (professional) => {
	if (professional?.certifications?.length) {
		return professional?.certifications.map((certif) => {
			const certifSpecializations = professional.specialties
				?.filter(
					(spec) =>
						spec.resource_type_id === certif.resource_type_id ||
						(['CRT', 'RRT'].includes(certif.resource_type) && spec.code.startsWith('RT_'))
				)
				.sort((a, b) => a.label.localeCompare(b.label));
			const states = [...certif.states];
			states.sort((a, b) => a.code.localeCompare(b.code));
			return {
				...certif,
				states,
				specialties: certifSpecializations
			};
		});
	}
	return [{ resource_type: '-', specialties: [], states: [] }];
};

const getProfessionalCityState = (professional) => {
	const address = [];
	if (professional.city_name) {
		address.push(professional.city_name);
	}

	if (professional.state_code) {
		address.push(professional.state_code);
	}

	if (!address.length) {
		return <span>-</span>;
	}
	return <h4>{address.join(', ')}</h4>;
};

const ProfessionalEmployeeDetails = ({ isFetching, professional, setShowEditIcon, isFlex, EmployeeIdsSection }) => {
	const professionalCertifications = mapCaregiversCertifications(professional);

	useEffect(() => {
		if (!isFetching && professional && !isFlex) {
			setShowEditIcon(professional.roles_no <= 1);
		}
	}, [professional, isFetching, setShowEditIcon, isFlex]);

	if (isFetching) {
		return (
			<div className="spinner-center-wrapper" key="spinner">
				<LoadingSpinner className="saving-spinner" />
			</div>
		);
	}

	if (!professional && !isFetching) {
		return null;
	}

	return (
		<WithOnlyOnDesktop>
			<div className="employee-details__wrapper">
				<div className="name-and-licenses__wrapper">
					<h2>Profile</h2>
					<div className="details__wrapper">
						<div className="details">
							<h3>Name</h3>
							<h4>
								{professional.first_name || '-'} {professional.last_name || '-'}
							</h4>
						</div>
						{!isFlex && professional.roles_no === 1 && (
							<>
								<div className="details">
									<SSNField label="SSN" value={professional.ssn} />
								</div>
								<div className="details">
									<h3>Date of Birth</h3>
									<h4>{professional.birth_date ? moment(professional.birth_date).format('MM/DD/YYYY') : '-'}</h4>
								</div>
							</>
						)}
					</div>
					<div className="home-details__wrapper">
						{professionalCertifications.map((certif) => (
							<div className="home-details-license__wrapper" key={certif.resource_type_id || Math.random() * 100}>
								<div className="home-details license-type">
									<h3>License Type</h3>
									<h4>{certif.resource_type}</h4>
								</div>
								<ProfessionalsSubtype subtypeTitle="State" subtypes={certif.states} type="code" />
								<ProfessionalsSubtype subtypeTitle="Specialties" subtypes={certif.specialties} type="label" />
							</div>
						))}
					</div>
				</div>

				{isFlex && <EmployeeIdsSection />}

				<div className="name-and-licenses__wrapper">
					<h2>Home Address</h2>
					<div className="home-details__wrapper">
						<div className="home-details">
							<h3>Street Address</h3>
							<h4>{professional.address || '-'}</h4>
						</div>
						<div className="home-details">
							<h3>City, State</h3>
							{getProfessionalCityState(professional)}
						</div>
						<div className="home-details">
							<h3>ZIP</h3>
							<h4>{professional.zip_code || '-'}</h4>
						</div>
					</div>
				</div>

				<div className="name-and-licenses__wrapper">
					<h2>Contact Information</h2>
					{!isFlex && (
						<div className="details__wrapper details">
							<h3>Preferred contact method</h3>
							<h4>{professional.preferred_contact_method_name || '-'}</h4>
						</div>
					)}
					<div className="details__wrapper details">
						<h3>Cell Phone</h3>
						<h4>{professional.phone_number || '-'}</h4>
					</div>
					<div className="details-email__wrapper">
						<h3>Email</h3>
						<h4>{professional.email || '-'}</h4>
					</div>
				</div>
			</div>
		</WithOnlyOnDesktop>
	);
};

export default ProfessionalEmployeeDetails;
